import { Reveal } from "./Reveal";
import { SECTION_IDS } from "../constants/site";

const TYPES = [
    {
        slug: "frost-free",
        name: "Frost Free",
        desc: "Degelo automático e praticidade no dia a dia.",
        img: "https://images.unsplash.com/photo-1630459065645-549fe5a56db4?q=80&w=900&auto=format&fit=crop",
        alt: "Geladeira Frost Free preta com dispensador de água",
    },
    {
        slug: "inverter",
        name: "Inverter",
        desc: "Motor inteligente: mais economia e silêncio.",
        img: "https://images.unsplash.com/photo-1484154218962-a197022b5858?q=80&w=900&auto=format&fit=crop",
        alt: "Geladeira Inverter em cozinha modular moderna",
    },
    {
        slug: "side-by-side",
        name: "Side by Side",
        desc: "Portas independentes e alta capacidade.",
        img: "https://images.unsplash.com/photo-1721613877687-c9099b698faa?q=80&w=900&auto=format&fit=crop",
        alt: "Geladeira Side by Side em ambiente integrado",
    },
    {
        slug: "inverse",
        name: "Inverse",
        desc: "Freezer na parte inferior e design sofisticado.",
        img: "https://images.pexels.com/photos/7027760/pexels-photo-7027760.jpeg?auto=compress&cs=tinysrgb&w=900",
        alt: "Geladeira Inverse em cozinha clara e moderna",
    },
];

export const FridgeTypes = () => (
    <section id={SECTION_IDS.tipos} className="scroll-mt-24 bg-fog py-20 sm:py-28" data-testid="fridge-types-section">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
            <Reveal>
                <p className="font-technical font-semibold uppercase tracking-[0.2em] text-sm text-brand">
                    Tipos de geladeira
                </p>
                <h2 className="mt-3 font-display font-black tracking-tight text-3xl sm:text-5xl text-graphite">
                    Consertamos toda a linha
                </h2>
            </Reveal>

            <div className="mt-10 sm:mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-6">
                {TYPES.map((t, i) => (
                    <Reveal key={t.slug} delay={i * 0.08} className="h-full">
                        <a
                            href={`https://wa.me/5534999901444?text=${encodeURIComponent(
                                `Olá preciso de uma visita técnica, minha geladeira é ${t.name}`
                            )}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid={`fridge-card-${t.slug}`}
                            className="group flex flex-col h-full bg-white rounded-3xl border border-mist overflow-hidden transition-all duration-300 hover:border-brand/50 hover:-translate-y-1.5 hover:shadow-[0_24px_50px_-20px_rgba(48,52,58,0.3)]"
                        >
                            <div className="relative overflow-hidden h-44 sm:h-48">
                                <img
                                    src={t.img}
                                    alt={t.alt}
                                    loading="lazy"
                                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-graphite/25 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                            </div>
                            <div className="flex flex-col grow p-5 sm:p-6">
                                <h3 className="font-display font-bold text-xl text-graphite">{t.name}</h3>
                                <p className="mt-1.5 text-sm text-graphite/65 leading-relaxed">{t.desc}</p>
                                <span className="mt-4 inline-flex items-center gap-1.5 font-display font-semibold text-sm text-brand">
                                    Chamar no WhatsApp
                                    <span className="transition-transform duration-300 group-hover:translate-x-1">→</span>
                                </span>
                            </div>
                        </a>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
